// =============================================================================
// Bento grid of /skills (large screens, 12 columns): rows of 2, 4, 3 and 4
// cards, repeated. An incomplete last row shares the whole width.
// =============================================================================

export const BENTO_ROWS = [2, 4, 3, 4] as const;

export type BentoCell = {
  /** Columns out of 12 */
  span: 3 | 4 | 6 | 12;
  /** Position in its row, to stagger the entrance */
  column: number;
};

export function getBentoCells(count: number): BentoCell[] {
  const cells: BentoCell[] = [];
  let row = 0;

  while (cells.length < count) {
    const size = BENTO_ROWS[row % BENTO_ROWS.length];
    const cards = Math.min(size, count - cells.length);
    const span = (12 / cards) as BentoCell["span"];
    for (let column = 0; column < cards; column += 1) {
      cells.push({ span, column });
    }
    row += 1;
  }

  return cells;
}

// =============================================================================
